/**
 * Error class for save sales portal cart operation
 */
export class SaveSalesPortalCartError extends Error {
  code: string;

  constructor({ message, code }: { code: string; message: string }) {
    super(message);
    this.name = 'SaveSalesPortalCartError';
    this.code = code;

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, SaveSalesPortalCartError);
    }
  }
}
